define('view/finder/external.org.finder.view',['require','exports','module','./base.finder.view','model/provisional.organization.model','uikit/uikit','handlebars','blockit','fukit','templates','fukit'],function(require, exports, module) {
  //prettier-ignore
  var BaseFinderView                = require('./base.finder.view'),
      ProvisionalOrganizationModel  = require('model/provisional.organization.model'),
      UIKit                         = require('uikit/uikit'),
      Handlebars                    = require('handlebars'),
      BlocKit                       = require('blockit'),
      FetchResourcesOnEventBehavior = require('fukit').FetchResourcesOnEventBehavior,
      TypeAheadSearchBehavior       = BlocKit.TypeAheadSearchBehavior,
      Templates                     = require('templates'),
      ExtendUtil                    = require('fukit').ExtendUtil;

  var SelectedTableCellView = UIKit.Table.CellView.extend({
    template: Templates.App['selected.table.cell'],
  });

  var SelectedTableRowView = UIKit.Table.RowView.extend({
    childView: SelectedTableCellView,
  });

  var SelectedTableView = UIKit.Table.extend({
    childView: SelectedTableRowView,
  });

  var externalOrgSearchablePageableTableView = BlocKit.SearchablePageableTableView.extend({
    internalViewOptions: BlocKit.SearchablePageableTableView.extendInternalViewOptions({
      visualSearchView: ExtendUtil.extendOptionValueWithDefaults('visualSearch', function() {
        var self = this;
        return {
          type: UIKit.Input.extend({
            options: _.extend({}, UIKit.Input.prototype.options, {
              icon: 'search',
              typeAheadFind: true,
            }),
            behaviors: function() {
              return {
                TypeAheadSearchBehavior: {
                  behaviorClass: TypeAheadSearchBehavior.extend({
                    handleBlur: function() {
                      this.clearSuggestions();
                    },
                    //'debounce' improve the performance of web applications. It is
                    // utilized when you only care about the final state of input.
                    // It also reduces number of calls to REST points.
                    handleChangeValue: _.debounce( function(inputValue, previousValue) {
                      console.log("input changed=", inputValue);
                      console.log("previousValue=", previousValue);
                      if (this.hasBeenSelected) {
                          this.hasBeenSelected = false;
                          return;
                      }
                      if(inputValue === null || inputValue === undefined) {
                        return;
                      }

                      if (this.isTyping) {
                          this.onChangeSearchValue(inputValue);
                      }

                      if (inputValue === '') {
                          self.collection.filters.set([]); //clear filters
                          self.collection.fetch(); // reload data for table below text area
                      }
                      else {
                        self.collection.filters.set([
                          { field: 'name', value: inputValue },
                          { field: 'active', value: true }
                        ])
                        self.collection.fetch();
                      }
                   }, 500),
                  }),
                  queryFields: ['name'],
                  allowFreeText: true,
                  autocompleteCollection: new (ProvisionalOrganizationModel.Collection.extend({}))(),

                  onResultSelected: function(resultView) {
                    var name = resultView.model.get("name");
                    console.log(name);
                    //update filters for collection and call fetch()
                    self.collection.filters.set([
                      { field: 'name', value: name },
                      { field: 'active', value: true }
                    ])
                    self.collection.fetch();
                  },

                }
              }
            },
          }),

        };
      }),
    }),
  });



  var ExternalOrgFinderView = BaseFinderView.extend({
    options: function() {
      return {
        emptyText: new Handlebars.SafeString(
          'This organization was not found. Use <strong>Request New External Org</strong> to submit a disclosure for this organization.'
        ),
        renderEmptyTextAsHtml: true,
        searchCollectionClass: ProvisionalOrganizationModel.Collection,
        searchFields: [
          {
            name: 'name',
            displayName: 'Name',
            searchableCollectionClass: ProvisionalOrganizationModel.Collection.extend({
              sort: {
                fieldName: 'name',
              },
            }),
            autocompleteCollectionClass: ProvisionalOrganizationModel.Collection.extend({
              sort: {
                fieldName: 'name',
              },
              filters: [
                {
                  field: 'active',
                  value: true,
                  hidden: true,
                },
              ],
            }),
            searchableName: 'name',
          },
        ],
        filters: [
          {
            field: 'active',
            value: true,
            hidden: true,
          },
        ],
      };
    },

    internalViewOptions: BaseFinderView.extendInternalViewOptions({
      searchTableView: function() {
        var filters = this.getOption('filters');
        return {
          columns: [{ text: 'Name', data: 'name' }],
          type: externalOrgSearchablePageableTableView,
          searchFields: this.getOption('searchFields'),
          filters: [].concat(this.getSearchFilters()).concat(_.isArray(filters) ? filters : []),
          simplePagination: true,
          collection: this.getSearchCollection(),
          table: {
            childView: UIKit.Table.RowView.extend({
              childView: SelectedTableCellView.extend({
                attributes: {
                  style: 'cursor: pointer;',
                },
              }),
            }),
            childViewOptions: {
              behaviors: {
                EnableOnlyWhenSelectableRecordBehavior: {
                  answerCollection: this.selectedCollection,
                  maxAnswerMultiplicity: this.getOption('maxAnswerMultiplicity'),
                  behaviorClass: BaseFinderView.EnableOnlyWhenSelectableRecordBehavior,
                },
                InvokeMethodOnEventBehavior: {
                  eventName: 'press',
                  method: this.addSelectedSearchRowToSelectedCollection,
                  context: this,
                  behaviorClass: BlocKit.InvokeMethodOnEventBehavior,
                },
              },
            },
            focusable: false,
            selectable: true,
            emptyText: this.getOption('emptyText') || 'Use the search box above to find records.',
            behaviors: {
              FetchResourcesOnEventBehavior: {
                resources: [this.getSearchCollection()],
                eventName: 'first:render',
                behaviorClass: FetchResourcesOnEventBehavior,
              }
            },
          },
        };
      },
      selectedTableView: function() {
        return {
          type: SelectedTableView,
          columns: [{ text: 'Name', data: 'name' }],
        };
      },
    }),
  });

  ExternalOrgFinderView.SelectedTableRowView = SelectedTableRowView;

  module.exports = ExternalOrgFinderView;
});

